import { ValueOf } from '@shared/types/common.ts';

export const UpsellPhases = {
  BUDGET: 'BUDGET',
  PACKAGES: 'PACKAGES',
} as const;

export type UpsellPhase = ValueOf<typeof UpsellPhases>;
